// import node module libraries
import { Col, Row, Card } from 'react-bootstrap';

const Version_00_00_02 = () => {
	return (
		<Row>
			<Col lg={12} md={12} sm={12}>
				<Card>
					<Card.Body>
						<Row className="g-0">
							<Col lg={3} md={4} sm={12}>
								<div id="initial">
									<h5 className="mb-3 fwsemi--bold">
										<code>v0.0.2</code> - 31 Okt. 2024
									</h5>
								</div>
							</Col>
							<Col lg={9} md={8} sm={12}>
								<div>
									<h4 className="mb-1 fw-semi-bold">🎃 Halloween Release</h4>
									<ul>
										<li>
											Neuer Flow für Bestellungen
										</li>
										<li>
											Kleine Fehlerkorrekturen und Optimierungen im Frontend
										</li>
									</ul>

									<div className="mb-3">
										<h4>Flows:</h4>
										<ul>
											<li>
												Neu - Rücksendungen ( Amazon &#8594; Mention )
												<br />
												<code>
													Flows/Rücksendungen
												</code>
											</li>
										</ul>
									</div>
								</div>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

export default Version_00_00_02;
